export type NeighborhoodFocusArea = {
  code: string;
  name: string;
  reach: number;
  population: string;
  users: string;
  adoption: string;
  engagement: string;
  growth: string;
};

export const neighborhoodFocusAreas: NeighborhoodFocusArea[] = [
  {
    code: "A",
    name: "Adamsville / MLK Corridor",
    reach: 18,
    population: "12,400",
    users: "224",
    adoption: "12.0%",
    engagement: "18.0%",
    growth: "3.4%",
  },
  {
    code: "D",
    name: "Downtown / Mechanicsville",
    reach: 27,
    population: "14,000",
    users: "378",
    adoption: "18.0%",
    engagement: "27.0%",
    growth: "6.2%",
  },
  {
    code: "E",
    name: "East Campbellton",
    reach: 21,
    population: "9,800",
    users: "206",
    adoption: "14.0%",
    engagement: "21.0%",
    growth: "2.8%",
  },
  {
    code: "V",
    name: "English Avenue / Vine City",
    reach: 24,
    population: "11,600",
    users: "278",
    adoption: "16.0%",
    engagement: "24.0%",
    growth: "4.1%",
  },
  {
    code: "G",
    name: "Grove Park / Bankhead",
    reach: 23,
    population: "13,200",
    users: "304",
    adoption: "15.4%",
    engagement: "23.0%",
    growth: "3.6%",
  },
  {
    code: "L",
    name: "Lakewood / Jonesboro Corridor",
    reach: 22,
    population: "10,900",
    users: "240",
    adoption: "14.7%",
    engagement: "22.0%",
    growth: "2.9%",
  },
  {
    code: "T",
    name: "Thomasville Heights",
    reach: 20,
    population: "10,100",
    users: "202",
    adoption: "13.3%",
    engagement: "20.0%",
    growth: "2.2%",
  },
  {
    code: "W",
    name: "West Campbellton",
    reach: 19,
    population: "8,700",
    users: "165",
    adoption: "12.6%",
    engagement: "19.0%",
    growth: "1.8%",
  },
];

export const neighborhoodRecommendations = [
  {
    code: "W",
    area: "West Campbellton",
    reach: 19,
    barrier: "Residents do not hear about programs in time",
    action: "Send SMS reminders and use flyers at local businesses",
  },
  {
    code: "T",
    area: "Thomasville Heights",
    reach: 20,
    barrier: "Venues are distant from transit connections",
    action: "Hold pop-ups at recreation centers and churches",
  },
  {
    code: "E",
    area: "East Campbellton",
    reach: 21,
    barrier: "Evening participation is constrained by childcare",
    action: "Pair family-friendly sessions with childcare support",
  },
  {
    code: "L",
    area: "Lakewood / Jonesboro Corridor",
    reach: 22,
    barrier: "Few nearby programs match stated interests",
    action: "Add rotating job and digital-skills programming",
  },
  {
    code: "G",
    area: "Grove Park / Bankhead",
    reach: 23,
    barrier: "Awareness varies across the combined area",
    action: "Coordinate outreach through trusted neighborhood partners",
  },
];
